<template>
    <div style="display: flex; justify-content: flex-end">
        <v-btn
            v-if="urlNextPost"
            color="blue darken-1"
            text
            class="pr-0"
            @click="$router.push(urlNextPost)"
        >
            {{ $t('posts.nextPost') }}
            <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'NextPostBtn',
    props: {
        urlNextPost: {
            type: String,
            default: ''
        }
    }
}
</script>
